import * as React from 'react';

var _rect, _rect2, _rect3, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgFastTrackOutline24 = function SvgFastTrackOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 80 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 15,
    width: 13,
    height: 3,
    rx: 1.5,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 22,
    width: 9,
    height: 3,
    rx: 1.5,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 28,
    width: 2.25,
    height: 3,
    rx: 1.125,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.948 16.383v32.103h5.002a5.485 5.485 0 0 1 5.389-4.427c2.673 0 4.9 1.905 5.389 4.427h25.811a5.485 5.485 0 0 1 5.39-4.43 5.485 5.485 0 0 1 5.388 4.43h4.544v-9.88l-5.288-2.636a2.5 2.5 0 0 1-1.084-1.049L59.464 16.383H18.949Zm41.564 34.029c.06.372.159.731.29 1.074H34.467A5.49 5.49 0 0 1 29.339 55a5.484 5.484 0 0 1-5.127-3.514h-5.764a2.5 2.5 0 0 1-2.5-2.5V15.883a2.5 2.5 0 0 1 2.5-2.5h41.314a2.5 2.5 0 0 1 2.199 1.31l10.091 18.662 5.424 2.704a2.5 2.5 0 0 1 1.385 2.237v10.69a2.5 2.5 0 0 1-2.5 2.5h-5.307a5.49 5.49 0 0 1-5.126 3.512 5.485 5.485 0 0 1-5.416-4.586Zm7.905-.885a2.48 2.48 0 0 1-2.489 2.47 2.48 2.48 0 0 1-2.488-2.47 2.48 2.48 0 0 1 2.489-2.47 2.48 2.48 0 0 1 2.488 2.47Zm-36.59.002A2.48 2.48 0 0 1 29.34 52a2.48 2.48 0 0 1-2.488-2.47 2.48 2.48 0 0 1 2.488-2.47 2.48 2.48 0 0 1 2.488 2.47Z",
    fill: "currentColor"
  })));
};

var FastTrackOutline24Svg = SvgFastTrackOutline24;

export { FastTrackOutline24Svg as default };
//# sourceMappingURL=FastTrackOutline24.svg.js.map
